import React, { useEffect, useState, useContext } from "react";
import "../../Assessts/Styles/SamagraDashboard/StudentDirectory.scss";
import axiosInstance from "../../../ReusableComponents/Axios";
import { useSelector } from "react-redux";
import DropdownValues from "../../../Student/Reusablecomponents/DropDownValues";
import { useNavigate } from "react-router-dom";
import { LoadContext } from "../../../ReusableComponents/LoadingContex";
import { exportToExcel } from "../../../Student/Reusablecomponents/RegularFunctions";
import notify from "../../../ReusableComponents/ToastifyAlerts";
const StudentDirectory = () => {
  const navigate = useNavigate();
  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const SelectDate = useSelector((state) => state.DateDetailsData.DateDetails);
  const USYear = useSelector((state) => state.SelecYearData.SYear);
  const { SetLoad } = useContext(LoadContext);

  const [GradeOptions, SetGradeOptions] = useState();
  const [SGrade, SetSGrade] = useState();
  const [Studentdetails, SetStudentDetails] = useState();
  const [PAFilter, SetPAFilter] = useState(false);
  const [search, setSearch] = useState("");
  // const [grade, setGrade] = useState("All");
  // const [district, setDistrict] = useState("All");
  // const [school, setSchool] = useState("All");
  const filteredStudents = Studentdetails?.filter((student) => {
    const matchesSearch =
      student.studentName.toLowerCase().includes(search.toLowerCase()) ||
      student.studentId.includes(search);

    // const matchesGrade = student.grade.split(" ")[1]?.trim() == SGrade;
    // SGrade === "All" || 

    // const matchesDistrict =
    //   district === "All" || student.district === district;

    // const matchesSchool =
    //   school === "All" || student.school === school;

    return (
      matchesSearch
      // &&
      // matchesGrade
      //  && matchesDistrict &&
      // matchesSchool
    );
  });
  const clearFilters = () => {
    setSearch("");
    // SetSGrade(GradeOptions?.[0]?.value);
    SetPAFilter(false);
    // setDistrict("All");
    // setSchool("All");
  };
  const GetStudentDeatils = async (Grade) => {
    SetLoad(true);
    try {
      const res = await axiosInstance.get(`/Principal/GetStudentPerformanceDirectory?SchoolId=${items?.schoolId}&ContestCreationId=${SelectDate?.value}&Grade=${Grade}&Participated=0&Absent=0`)
      SetStudentDetails(res.data);
      SetLoad(false);
    }
    catch (err) { console.log(err) }
  }
  const GetAssGrades = async () => {
    SetLoad(true)
    try {
      const res = await axiosInstance.get(
        `/NCLAdmin/GetGradeBasedOnInstituteAndSociety?AssessmentTypeNo=${SelectDate?.assessmentTypeNo}&InstituteId=${items?.instituteId}&Year=${USYear?.value}&SocietyId=${items?.societyId || 0
        }`,
      );
      const FormatedOptions = res.data?.[0]?.grade.split(",").map((item) => ({
        display: `Grade ${item.trim()}`,
        value: item.trim(),
      }));
      SetGradeOptions(FormatedOptions);
      SetSGrade(FormatedOptions[0]?.value);
      GetStudentDeatils(FormatedOptions[0]?.value)
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    GetAssGrades();
  }, [])

  const NavigateStudentReportcard = (student) => {
    navigate("/Principle/SamagraDashboard/SAMAGRAStudent", { state: { CCID: SelectDate?.value, StudentDetails: student, Grade: SGrade } })
  };

  const DownloadFile = () => {
    const Data = PAFilter ? filteredStudents.filter((item) => item.status === PAFilter) : filteredStudents
    const XL = Data?.map((item, index) => {
      const row = {
        SNo: index + 1,
        "Student ID": item.studentId,
        "Student Name": item.studentName,
        "Registered Grade": item.grade,
        District: item.district,
        School: item.schoolName,
        "English Mastery": item.englishMastery,
        "Math Mastery": item.mathsMastery,
        Status: item.status === "Participated" ? "✓ " : "✕ "
      };
      return row;
    })
    if(XL?.length > 0){
      exportToExcel(
        XL,
        `Student Subject Wise Result - {SelectDate?.examStartDate}`,
        false,
        "Subject Wise Result",
      );
    } else{
      notify("No data to download the file", "warning");
    }
  };
  return (
    <div className="student-directory">

      <div className="directory-header">
        <h1>Student Performance Directory</h1>
        <p> Complete list of all registered students with mastery levels </p>
      </div>
      <div className="filters-container">
        <div className="filters-left">
          <div className="search-box">
            <span className="search-icon">🔍</span>
            <input type="text" placeholder="Search by student name or ID..." value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
          <DropdownValues
            className="NCLDropdown"
            options={GradeOptions}
            onChange={(e) => { SetSGrade(e.target.value); GetStudentDeatils(e.target.value) }}
            selectoption={SGrade}
          />

          {/* <select
            value={district}
            onChange={(e) => setDistrict(e.target.value)}
          >
            <option>All</option>
            <option>Shivamogga</option>
          </select>

          <select
            value={school}
            onChange={(e) => setSchool(e.target.value)}
          >
            <option>All</option>

            <option>
              Sri Adichunchanagiri composite English High School
            </option>
          </select> */}

        </div>

        <div className="filters-right">
          <button className="export-btn" onClick={() => DownloadFile()}> 📥 Export Excel</button>
          <span className="badge participated" onClick={() => SetPAFilter("Participated")}>  Participated </span>
          <span className="badge absent" onClick={() => SetPAFilter("Absent")}> Absent </span>
          <button className="clear-btn" onClick={clearFilters} > Clear Filter </button>
        </div>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Student ID</th>
              <th>Student Name</th>
              <th>Registered Grade</th>
              <th>District</th>
              <th>School</th>
              <th>English Mastery</th>
              <th>Math Mastery</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>

            {(() => {
              const data = PAFilter
                ? filteredStudents.filter((item) => item.status === PAFilter)
                : filteredStudents;

              return data.length > 0 ? (
                data.map((student) => (
                  <tr
                    key={student.studentId}
                    onClick={() => NavigateStudentReportcard(student)}
                    className="CPointer"
                  >
                    <td className="student-id">{student.studentId}</td>
                    <td>{student.studentName}</td>
                    <td>{student.grade}</td>
                    <td>{student.district}</td>
                    <td>{student.schoolName}</td>
                    <td className="mastery english">{student.englishMastery}</td>
                    <td className="mastery math">{student.mathsMastery}</td>
                    <td>
                      <span
                        className={
                          student.status === "Participated"
                            ? "status participated-status"
                            : "status absent-status"
                        }
                      >
                        {student.status === "Participated" ? "✓ " : "✕ "}
                        {student.status}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} style={{ textAlign: "center" }}>
                    *** No records Found ***
                  </td>
                </tr>
              );
            })()}
          </tbody>
        </table>
      </div>
    </div>
  );
}
export default StudentDirectory;